"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationFinallyHooks = void 0;
class OperationFinallyHooks {
    static getTryCatchFinallyHook(_ctx) {
        return this;
    }
    static getPriority() {
        return 100;
    }
    static onTry(ctx) {
        ctx.onFinally = [];
        ctx.decoratorArgs?.onTry?.(ctx);
    }
    static onFinally(ctx) {
        for (const hook of ctx.onFinally) {
            try {
                hook();
            }
            catch (e) {
                const error = e;
                const loggerCtx = ctx;
                if (loggerCtx.logs)
                    loggerCtx.logs.push(`Error in onFinally hook: ${error?.message || error.toString()}`);
            }
        }
        ctx.decoratorArgs?.onFinally?.(ctx);
    }
}
exports.OperationFinallyHooks = OperationFinallyHooks;
//# sourceMappingURL=OperationFinallyHooks.js.map